import React from 'react';
import PropTypes from 'prop-types';
import padronizaLinks from 'volto-ministerio-publico-federal/helpers/Html/padronizaLinks';

/**
 * Bloco HTML (conteúdo migrado), igual ao do Volto 18 com uma diferença: os
 * links passam por `padronizaLinks`, que aplica o mesmo critério de aba do
 * resto do site (mesmo site na mesma aba, outro site em nova aba com aviso
 * acessível). Sem isso o HTML saía cru, com o `target` que cada editor
 * escolheu no Plone 5 — na mesma página, links de PDF ora em nova aba, ora na
 * mesma (bug 11153).
 */
const View = ({ data }) => (
  <div
    className="block html"
    dangerouslySetInnerHTML={{ __html: padronizaLinks(data.html) }}
  />
);

View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default View;
